module.exports = __webpack_public_path__ + "site/img/169.aab641c0.jpg";